import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../product/components/atoms/SecondaryButton'
import FullScreenPopup from '../../product/components/organisms/FullScreenPopup'
import UserContext from '../../product/context/user/userContext'
import CustomCommonContext from '../../custom/context/common/commonContext'
import AlertContext from '@/product/context/alert/alertContext'
import { Button } from '@mui/material'
import { LinearProgress } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Country as CSCCountry, State as CSCState } from 'country-state-city'
import moment from 'moment'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../product/common/components'
import { dateFormatFrontOnlyDate } from '../../custom/common/components'
import './UserManage.css'
import Loaders from '../../product/components/molecules/Loaders'
import VersaPayCardContext from '../../product/context/userThirdParty/payment/versapay/card/cardContext'
import Layout from '@/product/components/templates/Layout'
import VersaPayCardDetails from './VersaPayCardAdd'

const UserVersaPayView = (props) => {
    const alertContext = useContext(AlertContext)
    const userContext = useContext(UserContext)
    const customCommonContext = useContext(CustomCommonContext)
    const { setAlert } = alertContext

    const {
        get_all_card_details,
        getAllCards,
        responseStatus: responseStatusCard,
        clearResponse: clearResponseCard,
    } = useContext(VersaPayCardContext)

    const {
        single_custom_user,
        getUserDetails,
        userAction,
        responseStatus: responseStatusUser,
    } = userContext
    const [reload, setReload] = useState(false)

    const [isLoading, setIsLoading] = useState(false)
    const [cards, setCards] = useState([])
    const [address, setAddress] = useState([])
    const t = (text) => {
        text = text.charAt(0).toUpperCase() + text.slice(1)
        return text.replace(/_/g, ' ')
    }

    const validationArray = Yup.object({
        first_name: Yup.string()
            .min(2, 'Minimum 2 characters')
            .max(250, 'Maximum 250 characters')
            .required('Required!'),
        last_name: Yup.string()
            .min(2, 'Minimum 2 characters')
            .max(250, 'Maximum 250 characters')
            .required('Required!'),
        address1: Yup.string()
            .trim()
            .matches(
                /^[0-9a-zA-Z- ,.#()]*$/g,
                'Some kind of special characters not allowed'
            )
            .max(250, 'Maximum 250 Character')
            .required('Required!'),
        address2: Yup.string()
            .trim()
            .matches(
                /^[0-9a-zA-Z- ,.#()]*$/g,
                'Some kind of special characters not allowed'
            )
            .max(250, 'Maximum 250 Character'),
        email: Yup.string()
            .email('Invalid email format')
            .max(250, 'Maximum 250 characters')
            .required('Required'),
        phone: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required!'),
        country: Yup.string().trim().required('Required!'),
        city: Yup.string().required('Required!'),
        state: Yup.string().trim().required('Required!'),
        zip: Yup.string()
            .trim()
            .matches(/^[0-9]*$/g, 'The positive numeber only')
            .max(6, 'maximum 6 characters')
            .min(3, 'minimum 3 characters')
            .required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            email: '',
            confirm_email: '',
            first_name: '',
            last_name: '',
            address1: '',
            address2: '',
            phone: '',
            city: '',
            country: global.defaultCountry,
            state: '',
            zip: '',
            companyname: '',
            internalID: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            const value = values
            userAction(value)
        },
    })
    useEffect(() => {
        setIsLoading(false)
    }, [])
    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    }, [])
    useEffect(() => {
        let internalID = props.match.params.id
        console.log('internalID', internalID)
        if (internalID) {
            setIsLoading(true)
            let body = {
                fieldValue: internalID,
                field: 'internalId',
                custom: true,
            }
            // formik.values.id = internalID
            // getUserDetails(formik.values)
            getUserDetails(body)
        }
    }, [props.match.params.id])

    const getCyberSourceCards = () => {
        console.log('Coming to the Card')
        if (formik.values.id) {
            getAllCards({
                user_id: formik.values.id,
                object: 'card',
            })
        }
    }

    useEffect(() => {
        if (formik.values.id) {
            getCyberSourceCards()
        }
    }, [formik.values.id])

    useEffect(() => {
        if (
            get_all_card_details &&
            get_all_card_details.records.length
            // search_singlecart?.cartvalues?.total_amount <= configVariables?.stripe_ach_limit
        ) {
            setCards(get_all_card_details.records)
        } else {
            setCards([])
        }

        return () => {
            setCards([])
        }
    }, [get_all_card_details])

    useEffect(() => {
        if (single_custom_user.record) {
            const user = single_custom_user.record
            console.log('user', user)
            formik.setValues({
                // Here We Iniatalize the fields to show orignal data
                id: user.id,
                first_name: user.first_name,
                last_name: user.last_name,
                // passport_number: user.passport_number,
                // emirates_id: user.emirates_id ? user.emirates_id : '',
                companyname: user.companyname,
                phone: user.phone,
                email: user.email,
                confirm_email: user.email,
                state: user.state,
                city: user.city,
                address1: user.address1,
                address2: user.address2,
                zip: user.zip,
                country: user.country,
            })
            setCards([])
            setReload([])
        } else {
            resetFrom()
            setCards([])
            setReload([])
        }
        setIsLoading(false)
    }, [single_custom_user])

    const setUserAddress = () => {
        console.log('single_custom_user', single_custom_user?.record)
        if (
            single_custom_user?.record &&
            single_custom_user?.record?.address_details
        ) {
            console.log('single_custom_user Inside', single_custom_user?.record)
            setAddress(
                single_custom_user?.record?.address_details.filter(
                    (inner) => inner.status === 'active'
                )
            )
        }
    }

    useEffect(() => {
        setUserAddress()
    }, [
        single_custom_user?.record &&
            single_custom_user?.record?.address_details,
    ])

    useEffect(() => {
        const user = single_custom_user?.record
        if (user && user.country && formik.values.country === user.country) {
            formik.setFieldValue('state', user.state)
        } else {
            formik.setFieldValue('state', '')
        }
    }, [formik.values.country])

    const resetFrom = () => {
        formik.values.email = ''
        formik.values.address1 = ''
        formik.values.address2 = ''
        formik.values.city = ''
        formik.values.first_name = ''
        formik.values.last_name = ''
        formik.values.phone = ''
        formik.values.state = ''
        formik.values.zip = ''
        formik.values.country = global.defaultCountry
        formik.handleReset()
        setIsLoading(false)
    }

    const IndividualRegistration = {
        formik: formik,
        data: [
            {
                label: t('first_name') + '*',
                name: 'first_name',
                type: 'text',
                placeholder: t('enter_your_first_name'),
                class: 'col-12 col-sm-6',
                autoFocus: true,
                disabled: true,
            },
            {
                label: t('last_name') + '*',
                name: 'last_name',
                type: 'text',
                placeholder: t('enter_your_last_name'),
                class: 'col-12 col-sm-6',
                disabled: true,
            },
            {
                label: 'Company ' + '*',
                name: 'companyname',
                type: 'text',
                placeholder: 'Enter your company name',
                class: 'col-12 col-sm-6',
                disabled: true,
            },
            {
                label: t('email_address') + '*',
                name: 'email',
                type: 'email',
                placeholder: t('enter_your_email_address'),
                class: 'col-12 col-sm-6',
                disabled: true,
            },
        ],
    }

    const formSubmit = (e) => {
        formik.handleSubmit(e)
        console.log(formik.errors)
    }

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from === 'userAction') {
                formik.setSubmitting(false)
                setIsLoading(false)
            }
        }
    }, [responseStatusUser])

    const [manageCard, setManageCard] = useState({
        popup: false,
        status: 'new',
        data: null,
        user_id: null,
    })

    const toggleFullScreenCardPopup = (popup, status, data) => {
        setManageCard({ popup, status, data, user_id: formik.values.id })
    }

    useEffect(() => {
        if (responseStatusCard) {
            console.log('responseStatusCard', responseStatusCard)
            setAlert(responseStatusCard.message, responseStatusCard.status)
            clearResponseCard()
            if (
                responseStatusCard.from === 'createCard' ||
                responseStatusCard.from === 'defaultCard' ||
                responseStatusCard.from === 'deleteCard'
            ) {
                if (responseStatusCard.status === 'success') {
                    getCyberSourceCards()
                    toggleFullScreenCardPopup(false, 'new', null)
                }
            }
        }
    }, [responseStatusCard])

    return (
        <Layout>
            <div className="addUserModal userDetailsModal">
                <div className="fspBody">
                    {formik.isSubmitting ? <LinearProgress /> : null}
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <form onSubmit={formSubmit} autoComplete="nofill">
                            <div>
                                <h4 className="saTitle">Profile Details</h4>
                                <div className="row">
                                    {mapData(IndividualRegistration)}
                                </div>
                            </div>
                            <h4 className="saTitle">Saved Cards</h4>
                            <div className="savedCards">
                                <Button
                                    className="addNewButton"
                                    onClick={() =>
                                        toggleFullScreenCardPopup(
                                            true,
                                            'new',
                                            null
                                        )
                                    }
                                    id="addnewcard_button"
                                >
                                    <span className="material-icons">add</span>
                                    Add a new Card
                                </Button>
                                {cards &&
                                    cards.map((data, index) => (
                                        <div
                                            className="savedCardsCard"
                                            key={index}
                                        >
                                            <h4>
                                                EXP.&nbsp;&nbsp;&nbsp;&nbsp;
                                                {(
                                                    '0' + data.card_exp_month
                                                ).slice(-2) +
                                                    ' / ' +
                                                    data.card_exp_year}
                                            </h4>
                                            <h3>{data.card_number}</h3>
                                            {data.card_default ? (
                                                <h6 className="defaultSelection">
                                                    Default
                                                </h6>
                                            ) : null}

                                            <div className="d-flex justify-content-end mt-3">
                                                <Button
                                                    onClick={() =>
                                                        toggleFullScreenCardPopup(
                                                            true,
                                                            'update',
                                                            data
                                                        )
                                                    }
                                                    id="changecard_button"
                                                >
                                                    EDIT
                                                </Button>

                                                {!data.card_default ? (
                                                    <>
                                                        <Button
                                                            id="card_makedefault"
                                                            onClick={() =>
                                                                toggleFullScreenCardPopup(
                                                                    true,
                                                                    'default',
                                                                    data
                                                                )
                                                            }
                                                        >
                                                            Make Default
                                                        </Button>

                                                        <Button
                                                            id="card_delete"
                                                            onClick={() =>
                                                                toggleFullScreenCardPopup(
                                                                    true,
                                                                    'delete',
                                                                    data
                                                                )
                                                            }
                                                        >
                                                            Delete
                                                        </Button>
                                                    </>
                                                ) : null}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </form>
                    )}
                </div>
                <VersaPayCardDetails
                    allCards={cards}
                    data={manageCard}
                    preFillAddress={
                        address
                            ? address.sort((a, b) =>
                                  a.is_primary_billing < b.is_primary_billing
                                      ? 1
                                      : -1
                              )[0]
                            : null
                    }
                    function={toggleFullScreenCardPopup}
                />
            </div>
        </Layout>
    )
}

export default UserVersaPayView
